const joinRoute = [
  {
    path: '/join',
    component: () => import('@/views/join'),
    redirect: '/join/agent',
    meta: {
      title: '加入我们',
      breadcrumb: true,
      layout: "DefaultLayout"
    },
    children: [
      {
        path: 'agent',
        component: () => import('@/views/join/agent.vue'),
        meta: {
          title: '招商代理',
          breadcrumb: true,
        },
      },
      {
        path: 'recruit',
        component: () => import('@/views/join/recruit.vue'),
        meta: {
          title: '人才招聘',
          breadcrumb: true,
        },
      },
    ]
  },
]
export default joinRoute
